import type { ComponentType } from 'react';
import * as React from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const importErrorHandler = (err: string): { default: ComponentType<any> } => {
  // Get the last reload time from local storage and the current time
  const timeStr = sessionStorage.getItem('last-reload');
  const time = timeStr ? Number(timeStr) : null;
  const now = Date.now();

  // If the last reload time is more than 10 seconds ago, reload the page
  const isReloading = !time || time + 10_000 < now;
  if (isReloading) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.log('New version for this module found. Reloading ...');
    }
    sessionStorage.setItem('last-reload', String(now));
    window.location.reload();
    return { default: () => null };
  }

  // We let ErrorBoundary handle the error
  throw new Error(err);
};

export const appLazy = (factory: () => Promise<{ default: ComponentType<any> }>) => {
  return React.lazy(() => factory().catch(importErrorHandler));
};
